import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    console.error('App Error:', error, info);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight:'100vh', background:'#0A0A0A', display:'flex', alignItems:'center', justifyContent:'center', color:'#fff', fontFamily:'Arial,sans-serif', padding:20 }}>
          <div style={{ textAlign:'center', maxWidth:480 }}>
            <div style={{ fontSize:52, marginBottom:20 }}>⚠️</div>
            <h2 style={{ color:'#E74C3C', marginBottom:12, fontSize:22 }}>Something went wrong</h2>
            <p style={{ color:'#888', fontSize:14, lineHeight:1.8, marginBottom:24 }}>
              An unexpected error occurred. Please try refreshing the page.
            </p>
            <div style={{ background:'#111', border:'1px solid rgba(231,76,60,0.2)', borderRadius:10, padding:'12px 16px', marginBottom:24, fontSize:12, color:'#E74C3C', textAlign:'left', fontFamily:'monospace', wordBreak:'break-all' }}>
              {this.state.error?.message || 'Unknown error'}
            </div>
            <button onClick={() => window.location.href='/'} style={{ padding:'12px 32px', background:'#2ECC71', border:'none', borderRadius:10, color:'#000', fontWeight:900, fontSize:15, cursor:'pointer', marginRight:12 }}>
              Go Home
            </button>
            <button onClick={() => window.location.reload()} style={{ padding:'12px 32px', background:'transparent', border:'2px solid #2ECC71', borderRadius:10, color:'#2ECC71', fontWeight:700, fontSize:15, cursor:'pointer' }}>
              Refresh Page
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
